import React from 'react'
import PropTypes from 'prop-types'
import {feedCodeToTitle, LOCAL_KEY} from '../../constants'
import CFXProReactTable from '../cfxProReactTable'
import {reactTableColumn} from '../../helpers/reactTable'
import {buildLastUpdateFooter} from '../../helpers/textbuilders'
import {connect} from 'react-redux'
import {updateFeedData, updateIsFetchingFeedData} from '../../actions'
import api from '../../api'

@connect((state) => {
  const {
    data: {cpip, settlementindices},
    app: {isFetchingFeedData},
  } = state

  return {
    isFetchingFeedData,
    data: {...cpip, settlementindices},
  }
})
@api
class PriceInsurance extends React.Component {
  buildTableData(data, insurance) {
    if (
      data == null ||
      data[insurance] == null ||
      (insurance !== LOCAL_KEY.settlementIndices &&
        data[insurance].table == null)
    ) {
      return []
    }

    var tableData
    if (insurance === LOCAL_KEY.settlementIndices) {
      tableData = Object.assign([], data[insurance])
    } else {
      tableData = Object.assign([], data[insurance].table)
    }

    // Remove the first object as it has the header data
    tableData.shift()
    return tableData
  }

  buildTableColumns(data, insurance) {
    if (
      data == null ||
      data[insurance] == null ||
      (insurance !== LOCAL_KEY.settlementIndices &&
        data[insurance].table == null)
    ) {
      return []
    }

    var headerData = []
    if (insurance === LOCAL_KEY.settlementIndices) {
      headerData = data[insurance][0]
    } else {
      // First item in the list is the headers for the table
      headerData = data[insurance].table[0]
    }

    return Object.keys(headerData).map((key, index) => {
      // Headers for insurance data come in as "12 weeks\n10-Dec-18" for example.  We want to
      // change them to "10-Dec-18 12 weeks"
      const headerConst = headerData[key]
      var actualHeader = headerConst
      var h = headerConst.split('\n')
      if (key != 'a' && h.length > 1) {
        actualHeader = h[1] + ' ' + h[0]
      }
      return reactTableColumn(actualHeader, key)
      //return reactTableColumn(headerData[key], key)
    })
  }

  render() {
    const {
      data,
      isFetchingFeedData,
      apiInstance,
      dispatch,
      match: {
        params: {insurance},
      },
    } = this.props

    let tableData = this.buildTableData(data, insurance)
    let columns = this.buildTableColumns(data, insurance)
    let firstSecondaryColumn =
      columns == null || columns[0] == null ? '' : columns[0].Header
    let footerDate = data == null ? null : data.lastUpdated

    return (
      <div className="insurance">
        <CFXProReactTable
          useAutoWidth={true}
          fixedHeaders={true}
          footerText={buildLastUpdateFooter(
            'Courtesy of AFSC Price as of (date)',
            footerDate,
          )}
          titleText={feedCodeToTitle(insurance)}
          rightButtonIconName={
            isFetchingFeedData ? 'fa-sync-alt fa-spin' : 'fa-sync-alt'
          }
          rightButtonCallback={() => {
            dispatch(updateIsFetchingFeedData(true))
            apiInstance.get('getdata').then((data) => {
              dispatch(updateFeedData(data))
              dispatch(updateIsFetchingFeedData(false))
            })
          }}
          fixColumn={firstSecondaryColumn}
          data={tableData}
          loading={isFetchingFeedData}
          className="-striped -highlight"
          showPagination={false}
          defaultPageSize={tableData.length > 0 ? -1 : 5}
          columns={columns}
        />
      </div>
    )
  }
}

const propTypeInsuranceFeedTableItem = PropTypes.shape({
  a: PropTypes.string,
  b: PropTypes.string,
  c: PropTypes.string,
  d: PropTypes.string,
  e: PropTypes.string,
})

const propTypeInsuranceFeed = PropTypes.shape({
  date: PropTypes.string.isRequired,
  feedType: PropTypes.string.isRequired,
  table: PropTypes.arrayOf(propTypeInsuranceFeedTableItem),
})

PriceInsurance.propTypes = {
  height: PropTypes.number,
  data: PropTypes.shape({
    wcpipfed: propTypeInsuranceFeed.isRequired,
    albertacalf: propTypeInsuranceFeed.isRequired,
    albertafeeder: propTypeInsuranceFeed.isRequired,
    saskmancalf: propTypeInsuranceFeed.isRequired,
    saskmanfeeder: propTypeInsuranceFeed.isRequired,
  }),
}

export default PriceInsurance



// WEBPACK FOOTER //
// ./src/components/price/insurance.js